import { departuresFilterToFacet } from "@wojo/services";

export function getIsOnSaleFiltersParam(prefix: string): string {
    if (!!departuresFilterToFacet.isOnSale && !!prefix) {
        return `${prefix}filters=${departuresFilterToFacet.isOnSale}`;
    }
    return "";
}
